import { render } from "./SubAdmin.vue?vue&type=template&id=d701ff6c&scoped=true"
const script = {}

import "./SubAdmin.vue?vue&type=style&index=0&id=d701ff6c&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d701ff6c"]])

export default __exports__